import { navLinks, channels } from '../data';

export default function Footer() {
  return (
    <footer id="footer" className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-base"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">今日看瓜</span>
            </a>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合今日看瓜最新爆料与今日热点的入口型信息站，实时热点榜与快讯流把分散在
              各平台的瓜聚到一起，帮你快速判断当前最值得关注的事件。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1">
                <i className="ri-radio-2-line text-accent-600"></i>实时滚动
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-shield-check-line text-accent-600"></i>公开信源
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-off-line text-accent-600"></i>无需登录
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">快速导航</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                  关于本站
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">内容栏目</h4>
            <ul className="space-y-2.5">
              {channels.map((c) => (
                <li key={c.name}>
                  <a href="#channels" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="mb-3 text-sm font-semibold text-foreground-950">与我们联系</h4>
            <ul className="space-y-2.5 text-sm text-foreground-600">
              <li>
                <a href="#faq" className="inline-flex items-center gap-2 transition-colors hover:text-primary-600">
                  <i className="ri-question-line text-secondary-500"></i>常见问题
                </a>
              </li>
              <li>
                <a href="mailto:hello@example.com" className="inline-flex items-center gap-2 transition-colors hover:text-primary-600">
                  <i className="ri-mail-send-line text-secondary-500"></i>内容反馈
                </a>
              </li>
              <li>
                <a href="#about" className="inline-flex items-center gap-2 transition-colors hover:text-primary-600">
                  <i className="ri-feedback-line text-secondary-500"></i>意见收集
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 今日看瓜 · 本站仅做公开信息聚合展示，观点与立场均属原信源，转载内容版权归原作者所有。
          </p>
          <a
            href="#top"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:text-primary-600"
          >
            回到顶部
            <i className="ri-arrow-up-line"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}